export default 'https://tme.understood.org/assets/confusion_particles.30ee1675.glb'